import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import {
  CreateNeedFormDialog,
  CreateNeedFormDialogCallbackInput,
  CreateNeedFormDialogUniqueProps,
} from '../CreateNeedFormDialog';

const { useDialogForContext, useDialog: useFormDialog } = getDialogHooks<
  CreateNeedFormDialogUniqueProps,
  CreateNeedFormDialogCallbackInput
>(CreateNeedFormDialog);
export const useCreateNeedFormDialogForContext = useDialogForContext;
export default useFormDialog;
